let initialStore = {
  token: null,
  user: {
    userId: null,
    fname: "",
    lname: "",
    recordKeeper: null,
    quarterlyFeePercent: null,
    dateOfBirth: null,
    s4: null,
    accountValue: null,
    artesysPortfolioExists: null,
    artesysPortfolioCode: null,
    artesysPortfolioDescription: null,
    artesysPortfolioFeatures: [],
    //hoping to do this
    recommendedPortfolioId: null,
    recommendedPortfolio: null,
    manuallySelectedPortfolioDescription: null,
    recommendedPortfolioFeatures: [],
    //
    companyName: null,
    recordPlatform: null,
    isAuthorized: null,
    outsideAssetUserValues: [],
  },
  form: {
    lastScreen: 0,
    currentScreen: 1.5,
    entryId: 11,
    dateStarted: "2022-01-01T00:00:00",
    dateCompleted: "2023-01-01T00:00:00",
    questions: [],
    screenHistory: [],
    selectedPortfolioId: null,
    formCalculation: {
      formId: null,
      recommendedPortfolioId: 12,
      recommendedPortfolio:
        "{feesExpenses: 0, formCalculationId: 0, id: 12, max…}",
      manuallySelectedPortfolioId: 14,
      manuallySelectedPortfolio:
        "{feesExpenses: 0, formCalculationId: 0, id: 14, max…}",
      riskTakingAbility: 0,
      lossToleranceStrategy: 0,
      lossTolerance: 0,
      id: 36,
    },
    outsideAssetUserValues: [],
  },
  formOptions: {
    portfolios: {},
    assets: {},
    answerOptions: {},
    investmentStrategies: {},
    portfoliosKey: {
      portfolio1: "Offensive Conservative",
      portfolio2: "Offensive Moderate",
      portfolio3: "Offensive Growth",
      portfolio4: "Offensive Aggressive",
      portfolio5: "Defensive Conservative",
      portfolio6: "Defensive Moderate",
      portfolio7: "Defensive Growth",
    },
  },
  screens: [
    {
      id: "1.4",
      heading: "No Portfolio",
      type: "no-portfolio",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "1.5",
        },
      ],
    },
    {
      id: "1.5",
      heading: "Select Portfolio",
      type: "select-portfolio",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "They chose to take the recommended portfolio",
          condition: [
            {
              type: "screen",
              referenceId: "1.5",
              value: "proceed",
            },
          ],
          advanceToScreen: "1.9",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose to have a portfolio tailed to their tolerance for risk",
          condition: [
            {
              type: "screen",
              referenceId: "1.5",
              value: "recommendedRisk",
            },
          ],
          advanceToScreen: "3.1",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose to have a portfolio tailed to their goals or objectives",
          condition: [
            {
              type: "screen",
              referenceId: "1.5",
              value: "recommendedGoals",
            },
          ],
          advanceToScreen: "2.1",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose their own portfolio, overriding the recommended one",
          condition: [
            {
              type: "screen",
              referenceId: "1.5",
              value: "choose",
            },
          ],
          advanceToScreen: "1.6",
        },
      ],
    },
    {
      id: "1.6",
      heading: "Choose My Own Portfolio",
      type: "choose-own-portfolio",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "1.9",
        },
      ],
    },
    {
      id: "1.8",
      heading: "Financial Planning",
      type: "financial-planning",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "1.9",
        },
      ],
    },
    {
      id: "1.9",
      heading: "Accept Portfolio",
      type: "accept-portfolio",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "1.10",
        },
      ],
    },
    {
      id: "1.10",
      heading: "Done",
      type: "done-screen",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "1.11",
        },
      ],
    },
    {
      id: "1.11",
      heading: "Authorized User",
      type: "authorized-user",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "They chose to take the recommended portfolio",
          condition: [
            {
              type: "screen",
              referenceId: "1.11",
              value: "proceed",
            },
          ],
          advanceToScreen: "1.10",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose to have a portfolio tailed to their tolerance for risk",
          condition: [
            {
              type: "screen",
              referenceId: "1.11",
              value: "recommendedRisk",
            },
          ],
          advanceToScreen: "3.1",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose to have a portfolio tailed to their goals or objectives",
          condition: [
            {
              type: "screen",
              referenceId: "1.11",
              value: "recommendedGoals",
            },
          ],
          advanceToScreen: "2.1",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose their own portfolio, overriding the recommended one",
          condition: [
            {
              type: "screen",
              referenceId: "1.11",
              value: "choose",
            },
          ],
          advanceToScreen: "1.6",
        },
      ],
    },
    {
      id: "2.1",
      heading: "Goals-Based Start",
      type: "goals-based-start",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "They want to add other retirement assets",
          condition: [
            {
              type: "screen",
              referenceId: "2.1",
              value: "goalsAddAssets",
            },
          ],
          advanceToScreen: "2.2",
        },
        {
          conditionId: "llpp-0099",
          description: "They do not have assets to add",
          condition: [
            {
              type: "screen",
              referenceId: "2.1",
              value: "goalsRetirementAge",
            },
          ],
          advanceToScreen: "2.3",
        },
      ],
    },
    {
      id: "2.2",
      heading: "Goals - Other Retirement Accounts",
      type: "goals-other-retirement-accounts",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "2.3",
        },
      ],
    },
    {
      id: "2.3",
      heading: "Goals - Retirement Age",
      type: "goals-retirement-age",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "2.4",
        },
      ],
    },
    {
      id: "2.4",
      heading: "Annual Salary",
      type: "annual-salary",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "2.5",
        },
      ],
    },
    {
      id: "2.5",
      heading: "Contributions",
      type: "contributions",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "2.6",
        },
      ],
    },
    {
      id: "2.6",
      heading: "Retirement Goal Balance",
      type: "retirement-goal-balance",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "2.7",
        },
      ],
    },
    {
      id: "2.7",
      heading: "Review Results",
      type: "review-results",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to maximize benefits question",
          condition: [],
          advanceToScreen: "2.14",
        },
      ],
    },
    {
      id: "2.14",
      heading: "Maximize Benefits",
      type: "maximize-benefits-goals",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to next slide",
          condition: [],
          advanceToScreen: "2.9",
        },
      ],
    },
    {
      id: "2.9",
      heading: "Portfolio On Track",
      type: "has-portfolio-on-track",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to next slide",
          condition: [],
          advanceToScreen: "2.13",
        },
      ],
    },
    {
      id: "2.12",
      heading: "Defensive Goals-Based",
      type: "defensive-goals-based",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "They chose to take the recommended portfolio",
          condition: [
            {
              type: "screen",
              referenceId: "2.12",
              value: "proceed",
            },
          ],
          advanceToScreen: "1.9",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose their own portfolio, overriding the recommended one",
          condition: [
            {
              type: "screen",
              referenceId: "2.12",
              value: "choose",
            },
          ],
          advanceToScreen: "1.6",
        },
      ],
    },
    {
      id: "2.13",
      heading: "Offensive Goals-Based",
      type: "offensive-goals-based",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "They chose to take the recommended portfolio",
          condition: [
            {
              type: "screen",
              referenceId: "2.13",
              value: "proceed",
            },
          ],
          advanceToScreen: "1.9",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose their own portfolio, overriding the recommended one",
          condition: [
            {
              type: "screen",
              referenceId: "2.13",
              value: "choose",
            },
          ],
          advanceToScreen: "1.6",
        },
      ],
    },
    {
      id: "3.1",
      heading: "RTQ Start",
      type: "rtq-start",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "They want to add other retirement assets",
          condition: [
            {
              type: "screen",
              referenceId: "3.1",
              value: "rtqAddAssets",
            },
          ],
          advanceToScreen: "3.2",
        },
        {
          conditionId: "llpp-0099",
          description: "They do not have assets to add",
          condition: [
            {
              type: "screen",
              referenceId: "3.1",
              value: "rtqRetirementAge",
            },
          ],
          advanceToScreen: "3.3",
        },
      ],
    },
    {
      id: "3.2",
      heading: "RTQ - Other Retirement Accounts",
      type: "rtq-other-retirement-accounts",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.3",
        },
      ],
    },
    {
      id: "3.3",
      heading: "RTQ - Retirement Age",
      type: "rtq-retirement-age",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.5",
        },
      ],
    },
    {
      id: "3.4",
      heading: "Withdraw Money",
      type: "withdraw-money",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.5",
        },
      ],
    },
    {
      id: "3.5",
      heading: "Large Expenses",
      type: "large-expenses",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.6",
        },
      ],
    },
    {
      id: "3.6",
      heading: "Confidence",
      type: "confidence",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.7",
        },
      ],
    },
    {
      id: "3.7",
      heading: "Uncertainty",
      type: "uncertainty",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.8",
        },
      ],
    },
    {
      id: "3.8",
      heading: "Account Balance",
      type: "account-balance",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.9",
        },
      ],
    },
    {
      id: "3.9",
      heading: "Investing Potential",
      type: "investing-potential",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.10",
        },
      ],
    },
    {
      id: "3.10",
      heading: "Picking Investments",
      type: "picking-investments",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.11",
        },
      ],
    },
    {
      id: "3.11",
      heading: "Investing Concepts",
      type: "investing-concepts",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.12",
        },
      ],
    },
    {
      id: "3.12",
      heading: "Explaining Terms",
      type: "explaining-terms",
      logic: [
        {
          conditionId: "llpp-0011",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.13",
        },
      ],
    },
    {
      id: "3.13",
      heading: "Market Drop",
      type: "market-drop",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Adance to RTQ",
          condition: [],
          advanceToScreen: "3.14",
        },
      ],
    },
    {
      id: "3.14",
      heading: "Defensive RTQ",
      type: "defensive-rtq",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "They chose to take the recommended portfolio",
          condition: [
            {
              type: "screen",
              referenceId: "3.14",
              value: "proceed",
            },
          ],
          advanceToScreen: "3.15",
        },
        {
          conditionId: "llpp-0099",
          description:
            "They chose their own portfolio, overriding the recommended one",
          condition: [
            {
              type: "screen",
              referenceId: "3.14",
              value: "choose",
            },
          ],
          advanceToScreen: "1.6",
        },
      ],
    },
    {
      id: "3.15",
      heading: "Glidepath",
      type: "glidepath",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "3.16",
        },
      ],
    },
    {
      id: "3.16",
      heading: "Maximize Benefits",
      type: "maximize-benefits",
      logic: [
        {
          conditionId: "llpp-0099",
          description: "Advance to next slide. This is only visible to devs",
          condition: [],
          advanceToScreen: "1.9",
        },
      ],
    },
  ],
};

export default initialStore;
